@if (!loading) {
<div style="display: flex;gap:1rem;">
    <mat-form-field style="width: fit-content;" appearance="outline">
        <mat-label>År</mat-label>
        <input matInput [matDatepicker]="dp" [formControl]="date">
        <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="multi-year" (yearSelected)="setYear($event, dp)">
        </mat-datepicker>
    </mat-form-field>

    <app-autocomplete-chips [formControl]="departmentControl" label="Forretningsområde"
        [displayFn]="departmentsService.displayFn" [valueFn]="departmentsService.valueFn" [options]="departments"
        [multiple]="false"></app-autocomplete-chips>

    <button mat-raised-button color="primary" (click)="exportExcel()" style="margin-top: 10px;">Eksportér til
        Excel</button>
    <button mat-raised-button color="primary" (click)="exportPdf()" style="margin-top: 10px;">Eksportér til PDF</button>
</div>

<div class="table-container">

    <table mat-table matSort matSortActive="initials" matSortDirection="asc" matSortDisableClear class="mat-elevation-z2" [dataSource]="dataSource" multiTemplateDataRows>
        <ng-container matColumnDef="consultant">
            <th mat-header-cell *matHeaderCellDef> Konsulent </th>
            <td mat-cell *matCellDef="let row"><span
                    [style.font-weight]="row.consultant.name == 'Total' ? '600' : ''">{{row.consultant.name}}</span>
                @if (loadingRow === row) {
                <div class="row-loading">
                    <mat-spinner [diameter]="24"></mat-spinner>
                </div>
                }
            </td>
            <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
        </ng-container>
        <ng-container matColumnDef="initials">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Initialer </th>
            <td mat-cell *matCellDef="let row"> {{row.consultant.initials}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="personalRevenue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Forventet personlig omsætning for hele året som det er registreret i Hubspot"> Forventet personlig omsætning </th>
            <td mat-cell *matCellDef="let row" (click)="showDetails(row, 'personalRevenue')" class="right-align" [style.font-weight]="expandedElement === row && detailsType === 'personalRevenue' ? '600' : ''">
                {{row.personalRevenue | number:
                '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef class="right-align">{{totals.personalRevenue | number:
                '1.0-0'}}</td>
        </ng-container>
        <ng-container matColumnDef="invoicedPersonalRevenue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Udfaktureret  personlig omsætning pr. dags dato">Faktureret personlig omsætning </th>
            <td mat-cell *matCellDef="let row" (click)="showDetails(row, 'invoicedPersonalRevenue')"
                class="right-align" [style.font-weight]="expandedElement === row && detailsType === 'invoicedPersonalRevenue' ? '600' : ''">
                {{row.invoicedPersonalRevenue
                | number: '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef class="right-align">{{totals.invoicedPersonalRevenue
                | number: '1.0-0'}}</td>
        </ng-container>
        <ng-container matColumnDef="weightedPipeline">
            <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Vægtet pipeline for året beregnet ud fra salgsstadiet i Hubspot"> Vægtet pipeline </th>
            <td mat-cell *matCellDef="let row" (click)="showDetails(row, 'weightedPipeline')" class="right-align" [style.font-weight]="expandedElement === row && detailsType === 'weightedPipeline' ? '600' : ''">
                {{row.weightedPipeline | number:
                '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef class="right-align">{{totals.weightedPipeline | number:
                '1.0-0'}}</td>
        </ng-container>
        <ng-container matColumnDef="leads">
            <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Forventet LEAD Creator omsætning for hele året som det er registreret i Hubspot"> Leads </th>
            <td mat-cell *matCellDef="let row" (click)="showDetails(row, 'leads')" class="right-align" [style.font-weight]="expandedElement === row && detailsType === 'leads' ? '600' : ''"> {{row.leads |
                number: '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef class="right-align">{{totals.leads | number: '1.0-0'}}</td>
        </ng-container>
        <ng-container matColumnDef="realizedSales">
            <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Dit forventede totals for hele året, såfremt hele ordren faktureres i indeværende år"> Totalsalg </th>
            <td mat-cell *matCellDef="let row" (click)="showDetails(row, 'realizedSales')" class="right-align" [style.font-weight]="expandedElement === row && detailsType === 'realizedSales' ? '600' : ''">
                {{row.realizedSales | number: '1.0-0'}}
            </td>
            <td mat-footer-cell *matFooterCellDef class="right-align">{{totals.realizedSales | number: '1.0-0'}}</td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                @if (element.consultant.id) {
                <div class="element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <app-consultant-summary-details [details]="details" [consultantId]="detailsConsultantId"
                        [year]="getYear(date.value)" [type]="detailsType" [sortDirection]="sorter?.direction || 'asc'"></app-consultant-summary-details>
                </div>
                }
            </td>
        </ng-container>
        <tr mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"
            [class.expanded-row]="expandedElement === row" [class.loading-row]="loadingRow === row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
        <tr mat-footer-row class="footer-row" *matFooterRowDef="displayedColumns;sticky:true"></tr>
    </table>
</div>
}